export default {
  computed: {
    isMobile() {
      return /mobi/i.test(window.navigator.userAgent.toLowerCase())
    },
    isPc() {
      return !this.isMobile
    },
  },
  methods: {
    routeLink(name) {
      return this.$router.resolve({ name }).href
    },
  },
  mounted() {
    if (this.isMobile) {
      document.body.style.minWidth = 'auto'
    } else {
      document.body.style.minWidth = '1200px'
    }
    // let pcScripts = [
    //   'https://sec.yunaq.com/common-module/dist/header.js',
    //   'https://sec.yunaq.com/common-module/dist/footer.js',
    //   'https://sec.yunaq.com/common-module/dist/sidebar.js',
    // ]
    // let mobileScripts = [
    //   'https://m.yunaq.com/common-module/dist/yaq-h5-header.js',
    // ]
    // let scriptElements = document.getElementsByClassName('yunaq_script')
    // for (let item of scriptElements) {
    //   item.remove()
    // }
    // let scripts = this.isPc ? pcScripts : mobileScripts
    // for (let script of scripts) {
    //   let scriptElement = document.createElement('script')
    //   scriptElement.classList.add('yunaq_script')
    //   scriptElement.type = 'text/javascript'
    //   scriptElement.src = script
    //   document.body.appendChild(scriptElement)
    // }
  },
}
